"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const enums_1 = require("../../../common/enums");
const EventSummary_1 = __importDefault(require("../components/eventSummary/EventSummary"));
const EventTime_1 = __importDefault(require("../components/eventTime/EventTime"));
const EventNormal = (props) => {
    const { isDark, event, type, meta, endAt, isDarkColor, height } = props;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '-webkit-fill-available',
        } }, { children: [(0, jsx_runtime_1.jsx)(EventSummary_1.default, { summary: event.summary, isDark: isDark, type: type, isDarkColor: isDarkColor, event: event, height: height }), (meta === null || meta === void 0 ? void 0 : meta.showTime) ? ((0, jsx_runtime_1.jsx)(EventTime_1.default, { isDark: isDark, event: event, type: enums_1.EVENT_TYPE.NORMAL, endAt: endAt, isDarkColor: isDarkColor })) : null] })));
};
exports.default = EventNormal;
